import React from 'react';

export const HeartIcon = () => {
    return(
        <svg className="heart_icon" xmlns="http://www.w3.org/2000/svg" id="like" width="20" height="20" viewBox="0 0 20 20" stroke="#3281ED">
            <rect id="사각형_2246" data-name="사각형 2246" width="20" height="20" fill="#3281ed" opacity="0"/>
            <path id="like-2" data-name="like" d="M373.935,746.375l-7.012-6.825a4.533,4.533,0,0,1,0-6.525,4.84,4.84,0,0,1,6.7,0l.308.3.319-.311a4.839,4.839,0,0,1,6.7,0,4.527,4.527,0,0,1,0,6.524Zm-3.66-13.38a3.425,3.425,0,0,0-2.394.963,3.239,3.239,0,0,0,0,4.661l6.054,5.892,6.065-5.9a3.234,3.234,0,0,0,0-4.661,3.457,3.457,0,0,0-4.788,0l-1.277,1.243-1.265-1.232A3.424,3.424,0,0,0,370.275,732.995Z" transform="translate(-364.038 -728.666)" fill="#3281ed"/>
            <path id="합치기_17" data-name="합치기 17" d="M8928.483,14495.144l-6.362-6.366a3,3,0,0,1,0-4.241l1.415-1.415a3,3,0,0,1,4.242,0l1.54,1.54,1.541-1.54a3,3,0,0,1,4.245,0l1.412,1.415a3,3,0,0,1,0,4.241l-6.363,6.363a1.314,1.314,0,0,1-1.67,0Z" transform="translate(-8919.289 -14478.778)" fill="#ffffff"/>
        </svg>
    )
}

export const HeartFillIcon = () => {
    return(
        <svg className="heart_fill_icon" xmlns="http://www.w3.org/2000/svg" id="like" width="20" height="20" viewBox="0 0 20 20" stroke="#3281ED">
            <rect id="사각형_2246" data-name="사각형 2246" width="20" height="20" fill="#3281ed" opacity="0"/>
            <path id="like-2" data-name="like" d="M373.935,746.375l-7.012-6.825a4.533,4.533,0,0,1,0-6.525,4.84,4.84,0,0,1,6.7,0l.308.3.319-.311a4.839,4.839,0,0,1,6.7,0,4.527,4.527,0,0,1,0,6.524Zm-3.66-13.38a3.425,3.425,0,0,0-2.394.963,3.239,3.239,0,0,0,0,4.661l6.054,5.892,6.065-5.9a3.234,3.234,0,0,0,0-4.661,3.457,3.457,0,0,0-4.788,0l-1.277,1.243-1.265-1.232A3.424,3.424,0,0,0,370.275,732.995Z" transform="translate(-364.038 -728.666)" fill="#3281ed"/>
            <path id="합치기_17" data-name="합치기 17" d="M8928.483,14495.144l-6.362-6.366a3,3,0,0,1,0-4.241l1.415-1.415a3,3,0,0,1,4.242,0l1.54,1.54,1.541-1.54a3,3,0,0,1,4.245,0l1.412,1.415a3,3,0,0,1,0,4.241l-6.363,6.363a1.314,1.314,0,0,1-1.67,0Z" transform="translate(-8919.289 -14478.778)" fill="#3281ED"/>
        </svg>
    )
}

export const XIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" id="구성_요소_273_1" data-name="구성 요소 273 – 1" width="20" height="20" viewBox="0 0 20 20">
            <g id="사각형_2253" data-name="사각형 2253" fill="none" stroke="rgba(200,200,200,0)" stroke-width="1" opacity="0">
                <rect width="20" height="20" stroke="none"/>
                <rect x="0.5" y="0.5" width="19" height="19" fill="none"/>
            </g>
            <path id="X_close" d="M71.093,70.8l.074-.074.123-.127L75.8,66.093l-.292-.292L70.8,70.509l-.074-.074-.127-.123L66.093,65.8l-.292.292L70.509,70.8l-.074.074L70.312,71,65.8,75.509l.292.292L70.8,71.093l.074.074L71,71.29,75.509,75.8l.292-.292-4.634-4.634Z" transform="translate(-60.801 -60.801)" fill="none" stroke="#999" stroke-width="1"/>
        </svg>
    )
}


export const BottomArrowIcon = ({color}) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="6" height="8" viewBox="0 0 6 8">
            <text id="_" data-name="▼" transform="translate(0 6)" fill="#418ded" font-size="6" font-family="SegoeUI, Segoe UI">
                <tspan className="tspan" x="0" y="0" fill={color}>▼</tspan>
            </text>
        </svg>
    )
}



// WEBPACK FOOTER //
// ./src/estimate_list/assets/Icons.js